export default (window.environment || {});
